import { FaAmbulance, FaCalendar, FaClock } from "react-icons/fa";
import Slider from "../components/slider";
import WhoWeAre from "../components/who-we-are";
import Services from "../components/services";
import Blog from "../components/blog";


export default function Home() {

    const SCHEDULES = [
        {
            title: "Emergency Cases",
            icon: <FaAmbulance />,
            description: (
                <p className="text-white">
                    Our emergency care team is ready 24/7 to provide rapid, life-saving
                    treatment with compassion and expertise.
                </p>
            ),
        },
        {
            title: "Doctors Timetable",
            icon: <FaCalendar />,
            description: (
                <p className="text-white">
                    Access our doctors&apos; timetable to find the right specialist at the
                    right time, ensuring seamless and convenient care for your health
                    needs.
                </p>
            ),
        },
        {
            title: "Opening Hours",
            icon: <FaClock />,
            description: (
                <div>
                    <div className="flex justify-between">
                        <p className="text-white">Monday - Friday</p>
                        <p className="text-white">8:00 am - 10:00 pm</p>
                    </div>
                    <div className="flex justify-between mt-2">
                        <p className="text-white">Saturday</p>
                        <p className="text-white">9:00 am - 06:00 pm</p>
                    </div>
                </div>
            ),
        },
    ];

    return (
        <div>
            <Slider />
            <div className="container">
                <div className="schedule grid lg:grid-cols-3 gap-6 lg:gap-8">
                    {SCHEDULES.map((s, i) => (
                        <div
                            key={i}
                            className="p-8 rounded main-bg flex flex-col gap-5 relative schedule-item overflow-hidden"
                        >
                            <h4 className="text-white text-lg font-medium">{s.title}</h4>
                            {s.description}
                            <div className="schedule-icon">{s.icon}</div>
                        </div>
                    ))}
                </div>
            </div>
            <WhoWeAre />
            <Services />
            <Blog />
        </div>
    )
}


